// Minimal hash-free path router helpers. Only a handful of routes are needed;
// we'll graduate to react-router when the screen count grows.

export type Route =
  | { kind: "home" }
  | { kind: "room"; code: string }
  | { kind: "profile" }
  | { kind: "stats" }
  | { kind: "auth-callback" }
  | { kind: "not-found"; path: string };

export function parseRoute(pathname: string): Route {
  if (pathname === "/auth/callback") return { kind: "auth-callback" };
  if (pathname === "/" || pathname === "") return { kind: "home" };
  if (pathname === "/profile") return { kind: "profile" };
  if (pathname === "/stats") return { kind: "stats" };

  const roomMatch = /^\/room\/([0-9]{6})\/?$/.exec(pathname);
  if (roomMatch) return { kind: "room", code: roomMatch[1] as string };

  return { kind: "not-found", path: pathname };
}

export function navigate(path: string): void {
  if (window.location.pathname !== path) {
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
}
